<template>
  <v-app id="vapp">
    <AppBar v-if="!isMobile" />
    <MobileNavigation v-else />
    <Snackbar />
    <v-content id="content">
      <router-view />
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import AppBar from "./components/Appbar";
import Footer from "./components/Footer";
import MobileNavigation from "./components/MobileNavigation";
import Snackbar from "./components/Snackbar"

export default {
  name: "App",
  components: {
    AppBar,
    Footer,
    MobileNavigation,
    Snackbar
  },
  data: () => {
    return {
      isMobile: false,
    };
  },
  methods: {
    onResize() {
      this.isMobile = this.ismobile();
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  }
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="sass">
.btn-icon
  padding-left: 10px
  padding-top: 6px

.content-class
  margin: 0% 7%

.v-card
  background-color: transparent !important

.section
  background-color: transparent

.content
  box-sizing: content-box
  width: 100%
  align-items: center

.fixed-container
  display: flex
  flex-flow: column
  height: 100%

#vapp
  font-family: "Poppins", sans-serif !important
  font-display: swap

#content
  background-color: #FAFEFE

.card-title
  font-weight: 800 !important
  word-break: normal !important

.card-subtitle
  font-style: normal !important
  font-weight: normal !important
  font-size: 30px !important
  line-height: 38px !important

.small_text
  font-style: normal
  font-weight: normal
  font-size: 14px
  line-height: 22px

.simple_text
  font-style: normal
  font-weight: normal
  font-size: 16px
  line-height: 24px

.paragraphe
  font-style: normal
  font-weight: normal
  font-size: 20px
  line-height: 28px

.large_text
  font-weight: normal
  font-size: 24px
  line-height: 32px

@media screen and (max-width: 496px)
  .large_text
    font-weight: normal
    font-size: 16px
    line-height: 32px

.semibold
  font-weight: 600
  font-size: 14px
  line-height: 22px

.bold
  font-weight: 600

.regular_text
  font-size: 12px
  line-height: 20px

.minititle
  font-size: 20px
  line-height: 28px
  text-transform: uppercase

.regular-app-bar
  font-size: 16px
  line-height: 24px

.justified-text
  text-align: justify

.centered
  display: flex
  align-content: center
  justify-content: center

.clickable
  cursor: pointer
</style>
